import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Newsletter from './Newsletter';
import { goToPage } from '../../actions/environment';
// import { imageSizeTranslation } from '../../utils/image';
// import { translateObjectDefaultData, translateObjectData } from '../../utils/locale';
import { translate, prefix, urlify } from '../../utils/string';
import { purifier } from '../../utils/dom';
import s from './Footer.scss';

class Footer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			footerLinkOpen: false,
		};
	}

	footerLinkClickHandler = (e) => {
		if (window.innerWidth <= 600) {
			e.preventDefault();
			const index = Array.from(e.currentTarget.closest('nav').children).indexOf(e.currentTarget.parentNode);

			this.setState((prevState) => ({
				footerLinkOpen: prevState.footerLinkOpen === index ? false : index,
			}));
		}
	}

	render() {
		const { properties, setup, footer, navigation } = this.props;
		const { footerLinkOpen } = this.state;
		if (properties.siteInitiated === false || properties.siteClosed === true) return null;

		// const magazineUri = translateObjectDefaultData(setup, magazine.posts[0].meta);

		return (
			<div className={s.pageEnd}>
				<div className={s.manifest} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'aplaceManifest')) }} />
				{/*
				<div className={s.magazineSnippets}>
					<h3 className={s.magazineSnippets_title}><Link to={prefix(setup, magazineUri.fullUri)}><span>{ translate(setup, 'magazineSnippetTitle') }</span></Link></h3>
					<div className={s.magazineSnippets_inner}>
						{
							magazineSnippets?.content && magazineSnippets.content.slice(0, 3).filter((snippet) => !!snippet).map((snippet) => {
								const metaInfo = snippet.meta ? translateObjectDefaultData(setup, snippet.meta) : {
									fullUri: `${magazineUri.fullUri}/${translate(setup, snippet.uri)}`,
									title: snippet.title,
									image: snippet.metaImage,
									tags: snippet.tags || {},
								};

								const defaultSnippetLink = prefix(setup, metaInfo.fullUri);

								return (
									<div key={defaultSnippetLink} className={[s.magazineSnippets_column, 'a-editorialFooter'].join(' ')}>
										{
											metaInfo.image && (
												<Link to={defaultSnippetLink}>
													<img className={s.magazineSnippets_column_img} {...imageSizeTranslation('4', metaInfo.image)} />
													<span className={s.magazineSnippets_column_text_preHeader}>
														{
															Object.keys(metaInfo.tags).map((tag) => {
																const tagMeta = translateObjectData(setup, metaInfo.tags[tag]);
																return tagMeta.title || tagMeta.name;
															}).join(', ')
														}
													</span>
													<span className={s.magazineSnippets_column_text_headerText}>{ translate(setup, metaInfo.title) }</span>
													<span className={s.magazineSnippets_column_text_link}>{ translate(setup, 'magazineSnippetReadMoreDefault') }</span>
												</Link>
											)
										}
									</div>
								);
							})
						}
					</div>
				</div>
				*/}
				<div className={s.footer}>
					<div className={s.footer_top}>
						<div className={s.footer_top_newsletter}>
							<h5 className={s.footer_top_newsletter_header}>{ translate(setup, footer.signUpText) }</h5>
							<Newsletter />
						</div>
						<div className={s.footer_top_social}>
							<h5 className={s.footer_top_social_header}>{ translate(setup, footer.followText) }</h5>
							<div className={s.footer_top_social_icons}>
								{
									footer.socialMediaIcons.map((item) => {
										if (item.link.indexOf(/(http|mailto|tel)/) === -1) {
											return <a href={item.link} key={urlify(item.icon.url)} target="_blank" rel="noopener noreferrer nofollow"><img src={item.icon.url} alt={item.icon.alt} /></a>;
										}
										return <Link to={item.link} key={urlify(item.icon.url)} rel="nofollow"><img src={item.icon.url} alt={item.icon.alt} /></Link>;
									})
								}
							</div>
						</div>
					</div>
					<nav className={s.footer_menu}>
						{
							navigation.footer && navigation.footer.map((menu, i) => (
								<div className={[s.footer_menu_column, ...(footerLinkOpen === i ? [s.footer_menu_column__expanded] : [])].join(' ')} key={translate(setup, menu, 'title')}>
									<Link className={s.footer_menu_column_headline} to={prefix(setup, translate(setup, menu, 'uri'))} onClick={this.footerLinkClickHandler}><h5>{ translate(setup, menu, 'title') }</h5></Link>
									{
										menu.subPages && menu.subPages.map((link) => (
											<Link className={s.footer_menu_column_link} key={translate(setup, link, 'title')} to={prefix(setup, translate(setup, link, 'uri'))}>{ translate(setup, link, 'title') }</Link>
										))
									}
								</div>
							))
						}
					</nav>
					<div className={s.footer_service}>
						{
							footer.serviceIcons.map((item) => (
								<img key={urlify(item.iconGrayscale.url)} className={s.footer_service_icon} src={item.iconGrayscale.url} alt={item.iconGrayscale.alt} />
							))
						}
					</div>
					<span className={s.footer_organisation}>{translate(setup, footer.organisationInfo)}</span>
				</div>
			</div>
		);
	}
}

const mapState = ({ environment }) => {
	const { properties, setup, footer, navigation } = environment;
	return { properties, setup, footer, navigation }; // magazine, magazineSnippets: listing.magazine
};

export default connect(mapState, { goToPage })(Footer);
